import template from './swag-cms-extensions-preview-custom-form.html.twig';
import './swag-cms-extensions-preview-custom-form.scss';

export default {
    template,
}
